exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".City-module__wrapper____u2nl{width:40px;height:40px}@media screen and (min-height:1000px){.City-module__wrapper____u2nl{position:relative}}.City-module__wrapper____u2nl button img{height:100%}.City-module__wrapper____u2nl .City-module__background___S_mqL{border-radius:15px;background-color:#f4f4f4;padding:15px}@-moz-document url-prefix(){.City-module__wrapper____u2nl .City-module__background___S_mqL{margin-bottom:15px}}.City-module__wrapper____u2nl .City-module__background___S_mqL p{margin-top:15px;margin-bottom:5px;font-weight:750}", ""]);

// exports
exports.locals = {
	"wrapper": "City-module__wrapper____u2nl",
	"background": "City-module__background___S_mqL"
};